export default __webpack_public_path__ + "static/media/spectra-com19.d1f50c95.jpg";